const debounce = fn => {
    // Setup a timer
    let timeout;
  
    return () => {
      // Setup the arguments
      const context = this;
      // eslint-disable-next-line no-undef
      const args = arguments;
  
      // If there's a timer, cancel it
      if (timeout) {
        window.cancelAnimationFrame(timeout);
      }
  
      // Setup the new requestAnimationFrame()
      timeout = window.requestAnimationFrame(() => {
        fn.apply(context, args);
      });
    };
  };
  
  export { debounce };
  